import React, {useEffect, useState} from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Title, Icon } from '../../../components/components';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FilterButton, { FilterGroup } from '../../../components/FilterButton';
import Tabs from '../../../components/Tabs';
import { useGetAppQuery } from '../../../api/appApiSlice';
import DataByDay from '../../../components/app/DataByDay';
import {DateRangeFilterButton} from "../../../components/DateRangeFilterButton";
import Kpis from "../../../components/metrics/Kpis";
import ConsentTab from '../../../components/app/ConsentTab';
import VersionTab from '../../../components/app/VersionTab';
import LazyLoad from '../../../components/LazyLoad';
import get from "lodash/get";

const App = () => {
  const appId = useParams()["appId"];
  const [filter, setFilter] = useState({})
  const { t } = useTranslation();
  const { data: app = {}, isSuccess } = useGetAppQuery({appId, filter})
  const { sdk_versions = [], app_versions = [] } = app
  const history = useHistory();

  if (! (app.bundle_id || app.bundle_id || app.devices ) ) { return(<></>) }

  return ( <>
    <Title main={app.publisher.name} sub={app.name} group={true} onBack={()=>(history.goBack())} >
      <Button onClick={()=>( window.location = `/apps/${appId}/cmp/analytics`) }>
        <Icon icon='configure' text={t("app.actions.cmp_analytics")} />
      </Button>
      <Button onClick={()=>( history.push(`/apps/${appId}/cmp/configuration`)) }>
          <Icon icon='check-square' text={t("app.actions.cmp_configuration")} />
      </Button>
    </Title>
    <Row>
      <FilterGroup fireOnChangeAtMount={true} onChange={setFilter} >
        <DateRangeFilterButton
          startDate={app.start_date}
          endDate={app.end_date}
        />
        <FilterButton
          title={t("app.app_version")}
          options={app_versions}
          search={true}
          includeAll={true}
          selected={get(filter, 'app_version')}
          name="app_version"/>
        <FilterButton
          title={t("app.sdk_version")}
          options={sdk_versions}
          search={true}
          includeAll={true}
          selected={get(filter, 'sdk_version')}
          name="sdk_version"/>
      </FilterGroup>
    </Row>
    <Kpis data={app}/>
    <Tabs active={"devices"}>
      <LazyLoad icon={"mobile"} as={"devices"}>
        <DataByDay appId={appId} filter={filter}/>
      </LazyLoad>
      <LazyLoad icon={"consent"} as={"consent"}>
        <ConsentTab appId={appId} filter={filter} />
      </LazyLoad>
      <LazyLoad icon={"version"} as={"version"}>
        <VersionTab appId={appId} filter={filter} setFilter={setFilter} />
      </LazyLoad>
    </Tabs>
  </> );
}

export default App;
